import { lazy } from 'react';
export var IFCModelScreen = lazy(function () { return import('./ifc-model.component'); });
